
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cluster/detail/[id]",
      function () {
        return require("private-next-pages/cluster/detail/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cluster/detail/[id]"])
      });
    }
  